export const design = {
  palette: {
    /**
     * The brand orange: the lightest shade of `orangeLight`'s hue and chroma
     * whose text and buttons stay above WCAG AA (4.5:1) on white and on MUI's
     * grey[50] (#fafafa). Dark backgrounds need `orangeLight` instead.
     */
    orange: `#c64b12`,
    /** The brand orange on dark backgrounds, where `orange` falls below AA. */
    orangeLight: `#e16432`,
    /** A darker shade of the brand orange, for links and hover states. */
    orangeDark: `#9d4623`,
  },
}

export const links = {
  documentation: `https://docs.oboku.me`,
  documentationConnectors: `https://docs.oboku.me/guides/connectors`,
  documentationKoreaderSyncServer: `https://docs.oboku.me/guides/koreader-sync-server`,
  documentationOpds: `https://docs.oboku.me/sync-providers/opds`,
  documentationSecrets: `https://docs.oboku.me/guides/secrets`,
  documentationStorage: `https://docs.oboku.me/guides/storage`,
  documentationSelfHosting: `https://docs.oboku.me/self-hosting/installation`,
  documentationSupport: `https://docs.oboku.me/support`,
  app: `https://app.oboku.me`,
  site: `https://oboku.me`,
  privacyPolicy: `https://oboku.me/privacy-policy`,
  linkedin: `https://www.linkedin.com/in/maxime-bret`,
  github: `https://github.com/mbret/oboku`,
  sponsor: `https://github.com/sponsors/mbret`,
  discord: `https://discord.gg/eB6MrMmmPN`,
  reddit: `https://www.reddit.com/r/oboku/`,
}
